/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserMdChat, faPhone, faVideo, } from '@fortawesome/pro-regular-svg-icons';
import { ListGroup } from './ListGroup';
import { ListItem } from './ListItem';
import { Clickable } from './Clickable';
import { FatRow } from './FatRow';
export var AppointmentModeField = function (_a) {
    var className = _a.className, modes = _a.modes, value = _a.value, onChange = _a.onChange;
    var hasChoice = modes.length > 1;
    return (jsx(ListGroup, { className: className },
        modes.includes('physical') && (jsx(ListItem, { as: Clickable, onClick: hasChoice
                ? function () {
                    onChange('physical');
                }
                : undefined },
            jsx(PhysicalModeDescription, { checked: hasChoice ? value === 'physical' : undefined }))),
        modes.includes('phone') && (jsx(ListItem, { as: Clickable, onClick: hasChoice
                ? function () {
                    onChange('phone');
                }
                : undefined },
            jsx(PhoneModeDescription, { checked: hasChoice ? value === 'phone' : undefined }))),
        modes.includes('video') && (jsx(ListItem, { as: Clickable, onClick: hasChoice
                ? function () {
                    onChange('video');
                }
                : undefined },
            jsx(VideoModeDescription, { checked: hasChoice ? value === 'video' : undefined })))));
};
export var PhysicalModeDescription = function (_a) {
    var className = _a.className, checked = _a.checked;
    return (jsx(FatRow, { className: className, checked: checked, title: jsx(Fragment, null,
            jsx(FontAwesomeIcon, { icon: faUserMdChat, sx: { mr: 2 } }),
            "In-person appointment"), meta: jsx(Fragment, null, "Come to the pharmacy just ahead of your appointment time and let a member of staff know you\u2019ve arrived.") }));
};
export var PhoneModeDescription = function (_a) {
    var className = _a.className, checked = _a.checked;
    return (jsx(FatRow, { className: className, checked: checked, title: jsx(Fragment, null,
            jsx(FontAwesomeIcon, { icon: faPhone, sx: { mr: 2 } }),
            "Phone call"), meta: jsx(Fragment, null, "We\u2019ll call you when it\u2019s time for your appointment. Make sure you\u2019re in a private place with good phone reception.") }));
};
export var VideoModeDescription = function (_a) {
    var className = _a.className, checked = _a.checked, children = _a.children;
    return (jsx(Fragment, null,
        jsx(FatRow, { className: className, checked: checked, title: jsx(Fragment, null,
                jsx(FontAwesomeIcon, { icon: faVideo, sx: { mr: 2 } }),
                "Video call"), meta: jsx(Fragment, null,
                !children && (jsx("span", null,
                    "Log back into this app at your scheduled appointment time to join your one-on-one video chat.",
                    ' ')),
                jsx("span", null, "Make sure you\u2019re in a private place with good internet.")) }),
        children));
};
//# sourceMappingURL=AppointmentModeField.js.map